// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IImageDto } from './image-dto.g';

export const imageBoxDto = {
    guid: 'guid',
    description: 'description',
    fileType_Name: 'fileType_Name',
    folderShardPath: 'folderShardPath',
    inactive: 'inactive',
    deleted: 'deleted',
    photoDto: 'photoDto',
    photoThumbDto: 'photoThumbDto',
} as const;

export type TImageBoxDto = (typeof imageBoxDto)[keyof typeof imageBoxDto];

export interface IImageBoxDto {
    [imageBoxDto.guid]: string | null;
    [imageBoxDto.description]: string | null;
    [imageBoxDto.fileType_Name]: string | null;
    [imageBoxDto.folderShardPath]: string | null;
    [imageBoxDto.inactive]: boolean | null;
    [imageBoxDto.deleted]: boolean | null;
    [imageBoxDto.photoDto]: IImageDto | null;
    [imageBoxDto.photoThumbDto]: IImageDto | null;
}

export class ImageBoxDto
    implements IImageBoxDto
{
    [imageBoxDto.guid]: string | null = null;
    [imageBoxDto.description]: string | null = null;
    [imageBoxDto.fileType_Name]: string | null = null;
    [imageBoxDto.folderShardPath]: string | null = null;
    [imageBoxDto.inactive]: boolean | null = null;
    [imageBoxDto.deleted]: boolean | null = null;
    [imageBoxDto.photoDto]: IImageDto | null = null;
    [imageBoxDto.photoThumbDto]: IImageDto | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IImageBoxData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[imageBoxDto.guid] = modelData[imageboxData.guid];
    }

    static create(modelData?: any | null): IImageBoxDto | null {
        return modelData ? new ImageBoxDto(modelData) : null;
    }
}
